import FUNCTION_API_BASE from "../functions";

export default {
  async getUserInfo(context) {
    const response = await fetch(`${FUNCTION_API_BASE}GetUserInfo`, {
      method: 'GET',
      headers: {"Authorization" : `Bearer ${context.rootGetters.accessToken}`},
    })

    const responseData = await response.json();

    context.commit('setUserInfo', {
      givenName: responseData.UserInfo.GivenName,
      surname: responseData.UserInfo.Surname,
      organization: responseData.UserInfo.Organization
    });
  },
  async updateUserInfo(context, payload) {
    const response = await fetch(`${FUNCTION_API_BASE}UpdateUserInfo`, {
      method: 'PATCH',
      headers:  {"Authorization" : `Bearer ${context.rootGetters.accessToken}`},
      body: JSON.stringify({
        GivenName: payload.givenName,
        Surname: payload.surname,
        Organization: payload.organization
      })
    })

    const responseData = await response.json();

    context.commit('setUpdateStatus', {
      status: responseData.Status,
    });
  }
}